// @ts-strict-ignore
import { GetQuizzesShowResponse } from 'mytours-read-api-typescript'
import { getApi, getConfiguration } from 'mytours-read-common'
import stqryBunnyReadApi from '../api/stqryBunnyReadApi'
import db from '../db'
import { DexieQuiz } from '../db/types'
import { getAccountId, shouldUsePublishedContent } from '../settings/functions'

export const loadQuiz = async (
	id: number,
	accountId: number | undefined,
	version: number,
	language: string,
	forseLoadFromNetwork?: boolean,
	onError?: (e: Error) => void,
): Promise<DexieQuiz> => {
	const platform = getConfiguration().getPlatform()
	const deviceUUID = getConfiguration().getDeviceUUID()
	const loadedQuiz = await db.quizzes.get({ id, version, language })
	if (loadedQuiz && !forseLoadFromNetwork) {
		return loadedQuiz
	}
	try {
		let quiz: GetQuizzesShowResponse
		if (shouldUsePublishedContent()) {
			quiz = await stqryBunnyReadApi.fetchQuiz(accountId || getAccountId(), id, version, language)
		} else {
			quiz = await getApi().quizzesShow(platform, id, version, language, deviceUUID)
		}
		const toDelete = []
		await db.quizQuestions
			.where('quiz_id')
			.equals(id)
			.eachPrimaryKey(key => toDelete.push(key))
		await db.quizQuestions.bulkDelete(toDelete)
		quiz.questions.map(async question => {
			await db.quizQuestions.put({ quiz_id: id, language, ...question }, question.id)
		})
		delete quiz.questions
		await db.quizzes.put(quiz, id)
		return quiz
	} catch (e) {
		onError?.(e)
		console.error('Error while loading quiz: ', e)
	}
}

export const saveResultToDB = async (
	questionId: number,
	quizId: number,
	answers: number[] | string,
	correct: boolean,
	attemptsUsed: number,
): Promise<void> => {
	await db.quizResults.put(
		{ question_id: questionId, quiz_id: quizId, answers, correct, attempts_used: attemptsUsed },
		questionId,
	)
}

export function generateQuizVersion(): number {
	return Math.round(new Date().getTime() / 100000)
}
